<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-card class="bCardAgenda">

      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">EXTENSION</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:end" class="textoSubtitulo">CÓDIGO: ECE_config_extención</p>
            </div>
          </b-col>
        </b-row>
      </b-container>


      <b-row>
          <b-col>
            <b-row align-v="center" align-h="end" class="m-3">
              <b-col>
                <b-form-group align="left">
                  <label for="nombreBusq">Palabra Clave</label>
                  <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-fill"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input name="nombre"
                                  placeholder="Nombre de la Extension"
                                  v-model="filtro.palabraClave"
                                  @keydown.enter.native="obtener"
                    >
                    </b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col></b-col>

              <b-col align="right">
                <b-button
                    v-if="$localStorageService.can('ECE_config_Extencion_crear')"
                    v-b-tooltip.hover title="Agregar Extension"
                    variant="outline-info"
                    @click="agregar()">
                    Agregar Extensión
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

      <div class="contenedorTablaSinColor">
        <b-row>
          <b-col sm="12" md="12" lg="12">
            <b-table
                id="TablaExtension"
                thead-tr-class="columnasTablaSinColor"
                :items="datosTabla"
                :fields="fields"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"
                responsive="true"
                class="parrafos"
                fixed>
              <template v-slot:cell(Acciones)="row">
                <b-button-group>
                  <b-button
                      v-if="$localStorageService.can('ECE_config_Extencion_editar')"
                      title="Modificar Extension"
                      size="sm"
                      variant="outline-warning"
                      @click="modificar(row.item)"
                  ><em class="fa fa-pencil"></em></b-button>

                  <b-button v-if="!row.item.registroActivo && $localStorageService.can('ECE_config_Extencion_inactivar')"
                            title="Activar Extension"
                            variant="outline-success"
                            size="sm"
                            @click="activarDesactivar(row.item)"
                  ><em class="fa fa-undo"></em></b-button>

                  <b-button v-else
                            title="Desactivar Extension"
                            variant="outline-danger"
                            size="sm"
                            @click="activarDesactivar(row.item)"
                  ><b-icon icon="trash-fill"></b-icon></b-button>
                </b-button-group>
              </template>
              <template v-slot:cell(fechaAlta)="row">
                {{ row.item.fechaAlta | formatoFechaCorta }}
              </template>
              <template v-slot:cell(fechaModificacion)="row">
                {{ row.item.fechaModificacion | formatoFechaCorta }}
              </template>
            </b-table>


            <div align="center" v-if="loader">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-if="!loader">
              <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
            <b-col v-if="!loader">
              <b-pagination
                  align="center"
                  v-model="paginaActual"
                  :total-rows="datosTabla.length"
                  :per-page="registrosPorPagina"
              ></b-pagination>
            </b-col>
          </b-col>
        </b-row>
      </div>

    </b-card>

    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="descripcion">Descripción</label>
                <validacion>*</validacion>

                <b-input-group size="sm" class="mb-2" id="nombre">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-textarea name="descripcion" placeholder="Descripción de la Extensión"
                                   v-model="$v.extension.descripcion.$model"
                                   :state="validateState('descripcion')"
                                   rows="3"
                                   max-rows="6"
                  ></b-form-textarea>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="extension">Extension</label>
                <b-input-group size="sm" class="mb-2" id="nombre">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="extension" placeholder="Extensión"
                                   v-model="$v.extension.extension.$model"
                                   :state="validateState('extension')"
                                type="number"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>

      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                    <b-spinner small></b-spinner>
                    Cargando...
                </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

export default {
  name: "extension",

  components: {Header},
  mixins: [validationMixin],

  data:()=>{
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      loaderAcciones: false,
      extensiones:[],

      datosTabla:[],
      fields:[
        {key: "idExtension", label:"ID Extension", sortable: true},
        {key: "descripcion", label:"Descripción", sortable: true},
        {key: "fechaAlta", label:"Fecha Alta", sortable: true},
        {key: "fechaModificacion", label:"Fecha Modificación", sortable: true},
          "Acciones",
      ],

      extension:{
        idExtension:null,
        descripcion: null,
        extension:null,
      },

      filtro:{
        idExtension: null,
        palabraClave: null,
        registroActivo: null
      },

      show: false,
      tituloModal: '',

      registrosPorPagina: 10,
      paginaActual: 1,
    }
  },
  validations: {
    extension: {
      descripcion: {required},
      extension:{required}
    }
  },
  created() {
    this.obtener();
    this.debug = this.$localStorageService.getDebug();
  },

  methods:{

    obtener() {
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + 'catalogos/obtenerListaExtensiones',this.filtro ).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosTabla.push(it);
              })
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    agregar() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.extension = {
        idExtension: null,
        descripcion: null,
        extension: null
      };
      this.tituloModal = 'Agregar Extensión';
      this.show = true;
    },
    modificar(item){
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.extension = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar Extensión';
      this.show = true;
    },
    submitGuardar() {
      this.$refs.submitGuardar.click();
    },
    guardar(){
      this.$v.extension.$touch();
      if (this.$v.extension.$anyError) {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Debes agregar la descripcion y extension",
        });
        return;
      }
      if (!this.$v.extension.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'catalogos/guardarExtension', this.extension).then(respuesta => {
              if (respuesta.data.data) {
                this.filtro = {
                  id: null,
                  palabraClave: null,
                  registroActivo: null,

                };
                this.obtener();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La extension se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    activarDesactivar(item){
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la extension?' : '¿Está seguro de activar la extension?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http.delete(this.$api + 'catalogos/activarDesactivarExtension?idExtension=' + item.idExtension).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La extension se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },


    validateState(name){
      const {$dirty, $error} = this.$v.extension[name];
      return $dirty ? !$error : null;
    },


    cerrarModal(){
      this.show = false;
    }
  }

}
</script>

<style scoped>
.bCardAgenda {
  margin: 2%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}

</style>